export default __webpack_public_path__ + "static/media/fp-icon.2261ef9c.webp";